import { styled } from '@mui/material/styles';


export const SectionStyle = styled('div')(
  ( { theme } ) => (
    {
      padding: theme.spacing(8, 0, 6, 0),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(10, 0, 15, 0),
      },
    }
  )
);
